import React, {
  useEffect,
  useMemo,
  useState
} from 'react';
import {
  connect
} from 'react-redux';

import Box from '../../hoc/Box/Box';
import api from '../../axios-local-api';
import * as actions from '../../store/actions/index';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import Spinner from '../../components/UI/Spinner/Spinner';
// import CustomerNetwork from '../CustomerNetwork/CustomerNetwork';
// import Pod from '../Pod/Pod';
// import Router from '../Router/Router';
// import { FaDownload } from 'react-icons/fa';
import Collapsible from 'react-collapsible';
import classes from './NetworkThread.css';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { useHistory, useLocation } from 'react-router-dom';

const NetworkThread = (props) => {
  const [upArrow, setUpArrow] = useState(true);
  const history = useHistory();
  const location = useLocation();
  const isSelected = location.pathname === '/threadnetworkoverview';

  useEffect(() => {
    props.getNetworkThread();
    props.getThreadRadioStatus();
  }, []);

  // Hide entirely if initial load failed
  if (props.threadInitialLoadFailed) {
    return null;
  }

  let arrow;
  if (upArrow) {
        arrow = (
          <MdKeyboardArrowUp
            color={'gray'}
            size={'30px'} />
        )
      } else {
        arrow = (
          <MdKeyboardArrowDown
            color={'gray'}
            size={'30px'} />
  
        )
      }

  let threadNetworks;

  const basicConfig = props.networkThread?.threadNetworkInfo?.basicThreadNetworkConfig || {};
  const connectedDevices = props.networkThread?.threadNetworkInfo?.connectedDeviceCount;

  if (props.networkThread === null || props.networkThreadLoading) {
    threadNetworks = (<Spinner />);
  } else {
    threadNetworks = (
      <>
        <div className={classes.Spacer} />
        <div
          id='threadNetwork'
          style={{ cursor: 'pointer' }}
          className={[classes.Equipment, isSelected ? classes.SelectedBgColor : ''].join(' ')}
          onClick={() => {
            if (props.setEquipmentSelection) {
              props.setEquipmentSelection({
                displayAllEquipment: false,
                type: 'threadNetwork',
                didClick: true,
              });
            } else {
              props.onSetSelectedEquipment({
                displayAllEquipment: false,
                type: 'threadNetwork',
                didClick: true,
              });
            }
            history.push('/threadnetworkoverview');
          }}
        >
          <div><b>Spectrum Thread Network</b></div>
          <div>Network name: {basicConfig.networkName || 'N/A'}</div>
          {/* <div>Thread Version: {basicConfig.channel || 'N/A'}</div> */}
          {/* <div>Connected Devices: {connectedDevices ?? 'N/A'}</div> */}
        </div>
      </>
    );
  }
  

  
  return (
     <div className={[classes.BodyRow, classes.BodyRow1].join(' ')}>
        <Collapsible
          transitionTime={100}
          open={upArrow}
          onOpening={() => setUpArrow(true)}
          onClosing={() => setUpArrow(false)}
          trigger={
            (<Box>
              <div>
                <div className={classes.BodyTitle}><b>Thread Network</b>
                  <button className={classes.OpenCloseButton} style={{ float: 'right' }} aria-label="open arrow">
                     {arrow}
                  </button>
                  </div>
                <div className={classes.BodyInfo}>
                  { threadNetworks }
                </div>
              </div>
            </Box>)}>

        </Collapsible>


      </div>
  );
};


const mapStateToProps = (state) => ({
  success: state.networkThread.networkThreadSuccess,
  error: state.networkThread.networkThreadFail,
  networkThreadLoading: state.networkThread.networkThreadLoading,
  networkThread: state.networkThread.networkThread,
  threadInitialLoadFailed: state.networkThread.threadInitialLoadFailed,
  selectedEquipment: state.equipment.selectedEquipment,
});

const mapDispatchToProps = (dispatch) => ({
  onResetNetworkThreadErrorSuccess: () => {
    dispatch(actions.resetNetworkThreadErrorSuccess());
  },
  getNetworkThread: () =>  dispatch(actions.getNetworkThread()),
  getThreadRadioStatus: () => dispatch(actions.getThreadRadioStatus()),
  onSetSelectedEquipment: (equipment) => dispatch(actions.setSelectedEquipment(equipment))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(NetworkThread, api));
